// Vue instances
import Header from '@vue-instances/Header';

// Modules (don't need to lazy load)
import stickyHeader from '@modules/stickyHeader';

export default function init() {
  // Vue instances
  Header();

  // Modules
  stickyHeader([...document.querySelectorAll<HTMLElement>('.js-sticky-header')]);
}
